import { t } from 'i18next';
import { Building2, Play, Users, Workflow } from 'lucide-react';

import { McpSvg } from '@/assets/img/custom/mcp';
import SidebarLayout, { SidebarItem } from '@/app/components/sidebar-layout';

const iconSize = 20;

export const AdminSecondSidebarLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const basePath = '/internal-admin/overview';
  const items: SidebarItem[] = [
    {
      title: t('Clients'),
      href: `${basePath}/clients`,
      icon: <Building2 size={iconSize} />,
    },
    {
      title: t('Users'),
      href: `${basePath}/users`,
      icon: <Users size={iconSize} />,
    },
    {
      title: t('Flows'),
      href: `${basePath}/flows`,
      icon: <Workflow size={iconSize} />,
    },
    {
      title: t('Executions'),
      href: `${basePath}/executions`,
      icon: <Play size={iconSize} />,
    },
    {
      title: t('MCPs'),
      href: `${basePath}/mcps`,
      icon: <McpSvg width={iconSize} height={iconSize} />,
    },
  ];

  // No page title: each section (Clients, Users…) carries its own, and the
  // sidebar already says where you are.
  return <SidebarLayout items={items}>{children}</SidebarLayout>;
};
